var path = '/app/vehicles/templates/vehicle.list.html';
var html = "<wor-table\n  [(data)]=\"vehicles\"\n  (query)=\"getVehicles($event.params)\"\n  [settings]=\"tableSettings\"\n  (row-click)=\"onRowClick($event)\"\n  (row-double-click)=\"onRowClick($event)\">\n</wor-table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
export default  path;